import type { Schema } from '@/api/client'

export type Step = Schema<'FollowUpStepOut'>

/** Channels a rung may use — `app/outreach/channels.SENDABLE`, which the API
 *  refuses anything outside of. **`sms` and `rcs` were here until 2026-09-07**,
 *  when the owner scoped outreach to email and WhatsApp; `ivr` went earlier, when
 *  AugStash deleted the channel. The vocabulary still admits all three and old
 *  rungs still resolve, so this list is what may be *chosen*, not what may be
 *  read. */
export const CHANNELS: readonly { value: string; label: string }[] = [
  { value: 'email', label: 'Email' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'linkedin', label: 'LinkedIn' },
]

/** `CapRequest.follow_ups_per_day: Field(ge=1, le=500)` in `api/app/v1/compose.py`. */
export const CAP_MIN = 1
export const CAP_MAX = 500
export const MAX_STEPS = 10

/** What `PUT /outreach/follow-ups/ladder` takes: the rungs without their read-only fields. */
export function ladderBody(steps: readonly Step[]): Schema<'LadderRequest'> {
  return {
    steps: steps.map((row) => ({
      step_no: row.step_no,
      label: row.label,
      wait_days: row.wait_days,
      channel: row.channel,
      angle: row.angle,
      enabled: row.enabled,
    })),
  }
}

/** The label a channel value is shown under; an unknown one is shown as stored. */
export function channelLabel(value: string): string {
  return CHANNELS.find((option) => option.value === value)?.label ?? value
}
